import React, { useState, useEffect } from "react";
import { Button, Col, Row, Card, CardBody } from "reactstrap";
import toast from "react-hot-toast";
import PrintHeader from "../../Components/PrintHeader/PrintHeader";
import NumberCommas from "../../Components/NumberCommas/NumberCommas";
import { formatDate } from "../../Components/FormatDate/FormatDate";
import CounterCashServices from "../../Services/QRCodeServices/CounterCashServices/CounterCashServices";
import LayoutWithBreadCrumb from "../../pages/Pages/Starter/LayoutWithBreadCrumb";

const CounterCashTransaction = () => {
  const [transactionData, setTransactionData] = useState([]);

  async function fetchTransactions() {
    try {
      const response = await CounterCashServices.getList();
      setTransactionData(response);
    } catch (error) {
      toast.error(error.response?.data || "Error fetching transaction details");
    }
  }

  useEffect(() => {
    fetchTransactions();
  }, []);

  const handlePrint = () => {
    window.print();
  };

  // Calculate totals
  const totalDebit = transactionData.reduce(
    (sum, item) => sum + (item.transactionType === "Debit" ? item.amount : 0),
    0
  );
  const totalCredit = transactionData.reduce(
    (sum, item) => sum + (item.transactionType === "Credit" ? item.amount : 0),
    0
  );
  const finalBalance =
    transactionData.length > 0
      ? transactionData[transactionData.length - 1].balance
      : 0;

  return (
    <React.Fragment>
      <LayoutWithBreadCrumb
        title="Counter Cash Transactions"
        pageTitle="Cash Transactions"
      >
        <PrintHeader reportTitle="Counter Cash Transaction Report" />
        <Row className="mb-2 d-print-none">
          <Col className="d-flex justify-content-end align-items-center">
            <Button
              color="outline-secondary"
              className="py-2 px-3 d-flex align-items-center shadow-sm ms-auto"
              onClick={handlePrint}
            >
              <i className="ri-printer-line fs-16 me-2"></i>
            </Button>
          </Col>
        </Row>
        <Card>
          <CardBody>
            <table className="table table-bordered table-stripped">
              <thead>
                <tr>
                  <th className="table-primary" style={{ width: "60px" }}>
                    SN
                  </th>
                  <th className="table-primary" style={{ width: "250px" }}>
                    Date
                  </th>

                  <th className="table-primary">Remarks</th>
                  <th className="table-primary" style={{ width: "150px" }}>
                    Debit
                  </th>
                  <th className="table-primary" style={{ width: "150px" }}>
                    Credit
                  </th>
                  <th className="table-primary" style={{ width: "150px" }}>
                    Balance
                  </th>
                </tr>
              </thead>
              <tbody>
                {transactionData.length > 0 ? (
                  transactionData.map((item, index) => (
                    <tr key={item.transactionId}>
                      <td>{index + 1}</td>
                      <td>
                        <div>{formatDate(item.valueDate)}</div>
                        <div style={{ fontSize: "0.8em", color: "#6c757d" }}>
                          {item.transactionId}
                        </div>
                      </td>
                      <td>{item.remarks}</td>
                      <td className="text-end">
                        <NumberCommas
                          number={
                            item.transactionType === "Debit" ? item.amount : 0
                          }
                        />
                      </td>
                      <td className="text-end">
                        <NumberCommas
                          number={
                            item.transactionType === "Credit" ? item.amount : 0
                          }
                        />
                      </td>
                      <td className="text-end">
                        <NumberCommas number={item.balance} />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No transactions available
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                <tr style={{ textAlign: "right" }}>
                  <td colSpan="3" className="fw-bold">
                    Total
                  </td>
                  <td className="fw-bold">
                    <NumberCommas number={totalDebit} />
                  </td>
                  <td className="fw-bold">
                    <NumberCommas number={totalCredit} />
                  </td>
                  <td className="fw-bold">
                    <NumberCommas number={finalBalance} />
                  </td>
                </tr>
              </tfoot>
            </table>
          </CardBody>
        </Card>
      </LayoutWithBreadCrumb>
    </React.Fragment>
  );
};

export default CounterCashTransaction;
